import { useRouter } from 'next/router';
import { trackCreativeView } from '@kcd/event-tracker';

import { usePlacementEvents } from '~/domains/mmp/queries';
import { useEffectOnce } from '~/hooks/lifecycle';
import { useBusinessIdStore } from '~/store/global/useBusinessIdStore';

import { EventCategoryList } from './EventCategoryList';
import { EventPlacementList } from './EventPlacementList';
import { MainImageSection } from './MainImageSection';
import { NoEvent } from './NoEvent';
import Terms from '../../components/Terms';

const EventContainer = () => {
  const router = useRouter();
  const { businessId } = useBusinessIdStore();
  const placement = `event_${router.query.placementName as string}`;
  const { data, isLoading } = usePlacementEvents(businessId, placement);

  useEffectOnce(() => {
    if (!data || !data?.[0]) return;

    trackCreativeView({
      adGroupId: data[0].adGroupId,
      creativeId: data[0].creativeId,
      placementName: data[0].name || '',
    });
  });

  if (isLoading) return null;

  if (!data || !data.length) {
    return <NoEvent />;
  }

  const {
    mainImage,
    couponIds = [], // 쿠폰이 없는경우도 존재
    ctaText,
    termsImage,
    categories = [],
  } = data[0];

  return (
    <>
      {mainImage && mainImage?.default && (
        <MainImageSection
          mainImage={mainImage}
          couponIds={couponIds}
          ctaText={ctaText}
        />
      )}
      <EventCategoryList categories={categories} />
      <EventPlacementList items={data[0]?.items} />
      {termsImage && <Terms termsImage={termsImage} />}
    </>
  );
};

export default EventContainer;
